import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

export const createWeb3Modal = async () => {
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        rpc: {
          56: "https://bsc-dataseed.binance.org/",
          // Add more chain RPC URLs if needed
        },
        chainId: 56,
        showQrModal: true,
        projectId: "dd80836ee92266048ab1d1006086bb33",
      },
      qrcodeModalOptions: {
        mobileLinks: ["metamask", "trust", "safepal"],
      },
    },
  };

  return new Web3Modal({
    cacheProvider: true,
    providerOptions,
    theme: "dark",
  });
};


// import Web3Modal from "web3modal";
// import { EthereumProvider } from '@walletconnect/ethereum-provider';

// export const createWeb3Modal = async () => {
//   const provider = await EthereumProvider.init({
//     projectId: "dd80836ee92266048ab1d1006086bb33", // replace with your project ID
//     chains: [56], // BSC chain
//     showQrModal: true,
//   });

//   // WalletConnectProvider has been replaced by EthereumProvider
//   const providerOptions = {
//     walletconnect: {
//       package: provider, // use provider from EthereumProvider
//       options: {
//         rpc: {
//           //56: "https://binance.llamarpc.com/rpc/01HEEY46R8D0ANCX2TDSYPCM91",
//           //56: "https://endpoints.omniatech.io/v1/bsc/mainnet/public ",//"https://bsc-dataseed.binance.org/", //"https://binance.llamarpc.com/",
//           //97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
//         },
//       },
//       qrcode: true,
//       qrcodeModalOptions: {
//         mobileLinks: ["metamask", "trust", "safepal"],
//       },
//     },
//   };

//   return new Web3Modal({
//     cacheProvider: true,
//     providerOptions,
//     theme: "dark",
//   });
// };





/*




import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

export const createWeb3Modal = () => {
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: "5d34d59184e544a2883d3145e4c5c281",
        rpc: {
          56: "https://bsc-dataseed.binance.org/",
          97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
        },
        chainId: 56,
      },
      qrcode: true,
      qrcodeModalOptions: {
        mobileLinks: ["metamask", "trust", "safepal"],
      },
    },
  };

  return new Web3Modal({
    cacheProvider: true,
    providerOptions,
    theme: "dark",
  });
};


import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { arbitrum, mainnet, polygon } from 'wagmi/chains'

const chains = [arbitrum, mainnet, polygon]
const projectId = 'dd80836ee92266048ab1d1006086bb33'

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)

function App() {
  return (
    <>
      <WagmiConfig config={wagmiConfig}>
        <HomePage />
      </WagmiConfig>

      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    </>
  )
}



import { useWeb3Modal } from '@web3modal/react'

function HomePage() {
  const { open, close } = useWeb3Modal()

  return <button onClick={() => open()}>Connect</button>
}




import { useAccount, useContract } from 'wagmi'



*/